import { ChartColumnStackedIcon, LayoutListIcon, MegaphoneIcon, UserRoundCheckIcon } from 'lucide-react'
import { Button } from '../ui'
import FeatureCard from './FeatureCard'
import { HomeContentBlock, HomeParagraph, HomeSection, HomeTitle } from './base'

const features = [
  {
    icon: <UserRoundCheckIcon className='w-8 h-8 stroke-1' />,
    title: 'Role-based access control',
  },
  {
    icon: <ChartColumnStackedIcon className='w-8 h-8 stroke-1' />,
    title: 'Visual Reports',
  },
  {
    icon: <MegaphoneIcon className='w-8 h-8 stroke-1' />,
    title: 'Notifications & Approvals',
  },
  {
    icon: <LayoutListIcon className='w-8 h-8 stroke-1' />,
    title: 'Dynamic Post Builder',
  },
]
const FeaturesStrip = () => {
  return (
    <HomeSection padding='base' layout='center'>
      <HomeContentBlock spacing='xl' className='flex flex-col items-center w-full'>
        <div className='flex flex-col items-center gap-4 text-center max-w-4xl'>
          <HomeTitle as='h2' size='section' align='center' className='font-bold'>
            Built for modern PR workflows
          </HomeTitle>
          <HomeParagraph align='center'>
            Send press releases, media guides, lineups, and any real-time alerts to the media. Coordinate credential
            requests, and manage game-day info. Give reporters a customized central hub for everything they need.
          </HomeParagraph>
        </div>

        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 w-full'>
          {features.map((feature) => (
            <FeatureCard key={feature.title} icon={feature.icon} title={feature.title} />
          ))}
        </div>

        <div className='w-fit'>
          <Button
            variant='outline'
            className='bg-white border-neutral-600 text-neutral-800 hover:bg-gray-100'
            onClick={() => window.open('https://calendly.com/rtsc-demo', '_blank')}
          >
            Request a demo
          </Button>
        </div>
      </HomeContentBlock>
    </HomeSection>
  )
}

export default FeaturesStrip
